export default {
  // Common words
  enter: "Unesi",
  next: "Dalje",
  previous: "Prethodno",
  finish: "Završi",
  returnToWebsite: "Povratak na web-stranicu",
  complete: "Dovrši",
  submit: "Pošalji",
  cancel: "Odustani",
  yes: "Da",
  no: "Ne",
  skip: "Preskoči",
  close: "Zatvori",
  discard: "Odbaci",
  save: "Sačuvaj",
  "thank-you": "Hvala",
  select: "Izaberi",
  hi: "Bok",
  hello: "Pozdrav",
  link: "Link",
  back: "Natrag",
  view: "Prikaži",
  continue: "Nastavi",
  of: "od",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Hvala što ste odvojili vreme, vaše povratne informacije oblikuju našu ponudu <br /> za budućnost.",
  "client-survey-how-likely-recommend":
    "Koliko je verovatno da biste nas preporučili drugima?",
  "client-survey-how-likely-note":
    "Na lestvici od 0 do 10, gde je 0 nimalo verovatno, a 10 izuzetno verovatno.",
  "client-survey-how-likely-recommend-question":
    "Koja je jedna stvar koju bismo mogli učiniti da biste nas verovatnije preporučili?",
  "step-of": "Korak {step} od {total}",
  step: "Korak {step}",
  "client-survey-how-satisfied-with-service": "Koliko ste zadovoljni uslugom",
  "client-survey-how-satisfied-with-service-question":
    "Koja je jedna stvar koju bismo mogli učiniti da se poboljšamo?",
  "client-survey-how-satisfied-with-food":
    "Koliko ste zadovoljni hranom koju primate od nas?",
  "client-survey-how-satisfied-with-food-question":
    "Koja je jedna stvar koju bismo mogli učiniti da se poboljšamo?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Koja je najbolja stvar u radu s nama? Izaberite sve što vam je važno.",
  "management-team": "Upravljački tim",
  "the-front-line-operations-team": "Operativni tim na prvoj liniji",
  "food-offering": "Ponuda hrane",
  innovation: "Inovacija",
  communication: "Komunikacija",
  "flexibility-and-responsiveness": "Fleksibilnost i odzivnost",
  billing: "Naplata",
  "health-and-hygiene-standards": "Standardi zdravlja i higijene",
  "if-other-please-specify": "Ako je drugo, navedite...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Na osnovu usluge koju pružamo, gde se najviše možemo poboljšati? Izaberite sve što vam je važno.",
  "please-can-we-have-some-more-detail": "Možete li nam dati više detalja?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Kako bismo razumeli vaše CSR prioritete, poredajte sledeće prema važnosti:",
  "sustainable-ingredients": "Održivi sastojci",
  "food-waste": "Otpad od hrane",
  "local-sourcing": "Lokalna nabava",
  "people-and-communities": "Ljudi i zajednice",
  "energy-reduction": "Smanjenje potrošnje energije",
  "working-with-local-communities": "Rad s lokalnim zajednicama",
  "environmental-choices": "Ekološki izbori",
  "meat-free": "Bez mesa",
  "less-plastic": "Manje plastike",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Želite li da vas kontaktiramo u vezi s vašim povratnim informacijama? Ako da, ostavite svoje kontakt podatke u nastavku",
  "full-name": "Ime i prezime",
  "email-address": "Adresa e-pošte",
  "phone-number": "Broj telefona",
  feedback: "Povratne informacije",
  "view-our-privacy-policy": "Pogledajte našu Politiku privatnosti",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Hvala što ste odvojili vreme za popunjavanje ankete!",

  // 404 Not Found
  "404-not-found": "404 Nije pronađeno",

  // Privacy Policy
  "privacy-policy": "Politika privatnosti",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Drago nam je čuti da se osećate pozitivno, voleli bismo znati zašto?",
  "employee-web-rating-feedback-step-1-negative":
    "Žao nam je čuti da se ne osećate najbolje, možete li nam reći zašto?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Postoji li još nešto što biste danas želeli podeliti s nama?",
  "employee-web-rating-feedback-step-2-information":
    "Imate li kakvih komentara ili povratnih informacija o svom današnjem iskustvu s nama?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Podelite s nama svoje današnje iskustvo...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Želite li nekome odati priznanje?",
  "no-employees-found": "Nije pronađen nijedan zaposleni",

  // Employee Web Rating Home
  "choose-location": "Izaberite lokaciju",
  "search-location": "Pretražite lokaciju",
  "feedback-anonymous":
    "Želite li da vaše povratne informacije ostanu anonimne?",
  "feedback-feeling-today": "Kako se danas osećate?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Hvala vam na povratnim informacijama!",
  "back-to-home": "Natrag na početnu",
  page: "Stranica",

  // Feedback Once Alert
  "feedback-once-alert":
    "Povratne informacije s ovog URL-a već su jednom dane.",

  // Front Customer Audit
  "please-answer-above-question": "Odgovorite na pitanje iznad.",
  "add-comments": "Dodajte komentare",
  "enter-answer": "Unesite odgovor",
  "add-upload-files": "Dodajte / učitajte datoteke",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Jeste li danas kupili lek u apoteci?",
  "were-you-asked-any-of-the-following":
    "Jesu li vas pitali nešto od sledećeg:",
  "who-is-the-medicine-for": "Za koga je lek?",
  "what-are-your-symptoms": "Koji su vaši simptomi?",
  "how-long-you-had-the-symptoms": "Koliko dugo imate simptome?",
  "what-action-you-have-already-taken": "Koje ste mere već poduzeli?",
  "are-you-taking-any-other-medication": "Uzimate li još neke lekove?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Jeste li čekali više od 10 minuta da budete posluženi?",
  "were-the-products-you-wanted-in-stock":
    "Jesu li proizvodi koje ste želeli bili na zalihi?",
  "were-the-staff-friendly-and-helpful":
    "Je li osoblje bilo ljubazno i susretljivo?",
  "did-you-receive-any-advice-about-your-medicines":
    "Jeste li dobili kakav savet o svojim lekovima?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Kakvo je bilo vaše današnje iskustvo s nama?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Hvala vam na vremenu i vašim odgovorima.",
  "would-also-like-to-rate-us-on-google":
    "Želite li nas takođe oceniti na Googleu?",
  "rate-us-now": "Ocenite nas sada",

  // Negative Chat Reply
  "select-skill": "Izaberite veštinu",
  "none-selected": "Ništa nije izabrano",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Možemo li vas kontaktirati u vezi s vašim današnjim iskustvom?",
  "write-here": "Pišite ovde...",
  "please-can-we-get-your-name": "Možete li nam reći svoje ime?",
  "please-enter-your-email": "Unesite svoju e-poštu:",
  "enter-your-phone-number": "Unesite svoj broj telefona:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Recite nam nešto više o svom iskustvu:",
  "you-have-already-submitted-rating": "Već ste poslali ocenu",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Žao nam je čuti da danas niste imali najbolje iskustvo s nama, možete li istaknuti što je pošlo po zlu?",

  // Positive Chat Reply
  "select-employee": "Izaberite zaposlenog",
  "we-d-love-to-know-who-looked-after-you-today":
    "Voleli bismo znati tko se danas brinuo o vama?",
  "what-stood-out-to-you-today": "Što vam se danas istaknulo?",
  "did-we-provide-exceptional-service-today":
    "Jesmo li danas pružili izuzetnu uslugu?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Imate li kakvih komentara ili povratnih informacija o svom današnjem iskustvu s nama?",

  // Client Connect Director
  "message-from-leadership": "Poruka uprave",
  "message-from-leadership-text":
    "Neprestano tražim načine kako poboljšati našu ponudu za naše klijente. Postoje li, prema vašem mišljenju, aspekti koje bismo mogli poboljšati?",
  "client-connect-director-another-note":
    "Usput, ako postoji određena tema kojom biste želeli da se naš tim pozabavi, slobodno je podelite. Ovde sam ne samo da slušam, već i da se uključim i delujem na osnovu vaših briga ili ideja.",
  "your-message-here": "Vaša poruka ovde",
  "visit-information": "Informacije o posetu",
  "visit-time-out": "Vreme odlaska",
  "contact-information": "Kontakt informacije",
  "client-connect-director-contact-information-text":
    "Kako bismo pružili bolju pomoć, ljubazno molimo vaše podatke, uključujući vaše ime, adresu e-pošte i kontakt broj. Te će nam informacije omogućiti da vam brzo odgovorimo i kontaktiramo vas.",
  name: "Ime",
  "enter-your-name": "Unesite svoje ime",
  email: "E-pošta",
  "enter-your-email": "Unesite svoju e-poštu",
  "contact-number": "Kontakt broj",
  "please-enter-your-name": "Unesite svoje ime",
  "please-enter-your-email-or-phone-number":
    "Unesite svoju e-poštu ili broj telefona",
  "invalid-email-address": "Nevažeća adresa e-pošte",
  "invalid-phone-number-format": "Nevažeći broj telefona za izabranu zemlju.",
  "no-match-found": "Nema poklapanja",
  "phone-number-must-be-digits-for-country":
    "Broj telefona mora imati {count} cifara za izabranu zemlju ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Broj telefona mora imati {min}–{max} cifara za izabranu zemlju ({current}/{max}).",
  "please-select-time": "Izaberite vreme",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Morate dati barem jedan odgovor pre slanja ankete.",

  // Mobile Survey Questions CheckBoxType
  comment: "Komentar",
  "comment-is-required": "Komentar je obavezan!",
  "minimum-selection-is": "Minimalni izbor je {min_options}",
  "maximum-selection-is": "Maksimalni izbor je {max_options}",
  "this-question-is-required": "Ovo pitanje je obavezno!",
  "please-fill-all-required-grid-rows": "Popunite sve obavezne redove tabele!",
  "please-fill-mandatory-fields-to-continue":
    "Popunite obavezna polja za nastavak",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Izaberite ispravne slikovne datoteke.",

  // Mobile Survey Questions EmployeeType
  loading: "Učitavanje",
  "getting-employee": "Učitavanje zaposlenog...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Izaberite ispravne slikovne ili videodatoteke.",
  "please-select-a-valid-file":
    "Izaberite ispravnu datoteku (slika, video, PDF ili Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Unesite broj bez decimalnih mesta.",
  "please-enter-a-number-less-than-or-equal-to":
    "Unesite broj manji ili jednak {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Dovršite svoj potpis.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address": "Unesite ispravnu adresu e-pošte.",
  "phone-number-should-be-10-digit": "Broj telefona treba imati 10 cifara.",
  "please-enter-at-least-characters":
    "Unesite barem {minimum_character} znakova.",
  "select-date": "Izaberite datum",
  "select-time": "Izaberite vreme",
  "client-connect-date-picker-aria": "Datum: {value}. Otvori birač datuma",
  "client-connect-time-picker-aria": "Vreme: {value}. Otvori birač vremena",
  "select-country": "Izaberite državu",

  // Report Page
  "click-the-link-to-see-how": "Kliknite link da vidite kako.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Dodavanjem svojih timova na ServeFirst platformu za izveštavanje i oni se mogu prijaviti kako bi videli svoj učinak; takođe imate mogućnost upravljati svojim timom i pristupiti dodatnim izveštajima kako biste razumeli kako uopšteno poslujete -",
  "did-you-know": "Jeste li znali..",
  count: "broj",
  average: "prosek",
  focus: "fokus",
  performance: "Učinak",
  "you-can-create-bespoke-action-plans":
    "Možete izraditi prilagođene akcijske planove koji se filtriraju izravno ovde ako su izrađeni unutar vašeg ServeFirst računa; ovde možete odmah izrađivati radnje, vremenske okvire i vlasnike uz praćenje učinka. -",
  "no-of-times-raised": "Broj puta pokrenuto",
  action: "Radnja",
  "attribute-name": "Naziv atributa",
  "action-plan": "Akcijski plan",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Dodavanjem svojih timova na ServeFirst platformu za izveštavanje i oni se mogu prijaviti kako bi videli svoj učinak; takođe imate mogućnost upravljati svojim timom i pristupiti dodatnim izveštajima kako biste razumeli kako uopšteno poslujete -",
  result: "Rezultat",
  category: "Kategorija",
  "your-location-vs-all-location": "Vaša lokacija u odnosu na sve lokacije",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Raščlamba odgovora",
  "trended-net-promoter-score": "Net Promoter Score s trendom",
  "trended-results": "Rezultati s trendom",
  "net-promoter-score-info":
    "Net Promoter Score zasniva se na % promotora (ocena 5/5) - % detraktora (ocena 1, 2 ili 3); više o Net Promoter Scoreu možete saznati klikom na sledeće",
  "customer-feedback": "Povratne informacije kupaca",
  logan: "Logan",
  "top-performer": "Najuspešniji",
  "rank-in-the-country": "Rang u državi",
  "ytd-score": "Rezultat od početka godine",
  "score-during-period": "Rezultat tokom perioda",
  "0-from-last-month": "0 od prošlog meseca",
  "total-responses-for-july-2021": "Ukupno odgovora za jul 2021.",
  promoter: "Promotor",
  "from-04-sep-2021-to-06-sep-2021": "Od 04. sep. 2021. do 06. sep. 2021.",
  "the-focus-currently-is-on": "Fokus je trenutno na",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 kupac naveo je ovo kao priliku.",
  "focus-for-the-month": "Fokus za mesec",
  "download-pdf": "Preuzmi pdf",

  // Report Page New Report
  "total-responses": "Ukupno odgovora",
  duration: "Trajanje",
  "customers-have-stated-this-as-an-opportunity":
    "kupaca navelo je ovo kao priliku",
  "error-fetching-params": "Greška pri učitavanju parametara!",
  "previous-days-was": "Prethodnih {days} dana bilo je {score}",

  // Report Page Common LgCard
  "raised-on": "# Pokrenuto",
  results: "Rezultati",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Analiziranje podataka, pričekajte...",

  // Report Page Components CustomerFeedBack
  "view-report": "Prikaži izveštaj",
  "received-on": "Primljeno",

  // Report Page Components ResponseBreakdown
  detractors: "Detraktori",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Rezultati trenda",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Učitavanje PDF datoteke nije uspelo",
  "error-generating-pdf-thumbnail": "Greška pri generiranju PDF sličice",
  "error-in-thumbnail-generation-function":
    "Greška u funkciji generiranja sličice",
  "failed-to-generate-pdf-thumbnail": "Generisanje PDF sličice nije uspelo",

  // Survey Pages Audition
  "select-audit": "Izaberite reviziju",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Izaberite barem {minOptions} opcija",
  "select-max-options": "Dopušteno je najviše {maxOptions} opcija!",
  "error-saving-your-response": "Greška pri čuvanju vašeg odgovora!",
  "failed-to-load-the-file": "Učitavanje datoteke nije uspelo!",
  "open-link": "Otvori link",
  download: "Preuzmi",
  details: "Detalji",
  title: "Naslov",
  description: "Opis",
  "general-info": "Opće informacije",
  type: "Vrsta",
  size: "Veličina",
  "uploaded-by": "Učitao",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Hvala vam na vremenu!",

  // Survey Pages ClientConnect Content
  "review-content": "Pregledaj sadržaj",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Dajte nam svoje povratne informacije",
  "enter-your-response": "Unesite svoj odgovor",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Zdravo, {name}",
  "client-connect-preview-sent-from": "Poslato od {sender} - {date}",
  "client-connect-preview-step-of": "Korak {current} od {total}",
  "client-connect-preview-getting-started": "Početak",
  "client-connect-preview-getting-started-desc":
    "Pogledajte uvodne resurse pripremljene za vas.",
  "client-connect-preview-share-feedback": "Podelite povratne informacije",
  "client-connect-preview-share-feedback-desc":
    "Vaše mišljenje nam pomaže da stvorimo bolje iskustvo za vas.",
  "client-connect-preview-talk-leadership": "Razgovor s vodstvom",
  "client-connect-preview-talk-leadership-desc":
    "Pročitajte poruku vodstva i sačuvajte svoj odgovor.",
  "client-connect-preview-reviewed-these": "Pregledao/la sam ovo",
  "client-connect-preview-send-feedback": "Pošalji povratne informacije",
  "client-connect-preview-finish-submit": "Završi i pošalji",
  "client-connect-preview-save-finish": "Završi i pošalji",
  "client-connect-preview-your-reply": "Vaš odgovor",
  "client-connect-preview-saved": "Sačuvano",
  "client-connect-preview-edit": "Uredi",
  "client-connect-preview-pop-out": "Otvori u prozoru",
  "client-connect-preview-open": "Otvori",
  "client-connect-preview-view": "Pregledaj",
  "client-connect-preview-welcome": "Dobrodošli",
  "client-connect-preview-feedback": "Povratne informacije",
  "client-connect-preview-save-message": "Pošalji poruku",
  "client-connect-preview-message-footer":
    "Vaša poruka ide direktno vodstvenom timu.",
  "client-connect-preview-leadership-placeholder": "Unesite svoju poruku...",
  "client-connect-preview-thank-you": "Hvala",
  "client-connect-preview-thank-you-body":
    "Završili ste Client Connect. Vaši odgovori na anketu i poruka poslati su timu — uskoro će vas kontaktirati.",
  "client-connect-thank-you-message":
    "Hvala vam na vremenu. Vaše povratne informacije zaista znače.",
  "client-connect-preview-review-answers": "Pregledaj moje odgovore",
  "client-connect-preview-back-dashboard": "Nazad na nadzornu ploču",
  "client-connect-preview-already-submitted":
    "Vaše povratne informacije su primljene. Hvala vam! Slobodno istražite materijale iznad.",
  "enter-email-address": "Unesite e-poštu",
  "enter-phone-no": "Unesite telefonski broj",
  "product-type": "Vrsta proizvoda",
  "enter-number": "Unesite broj",
  aspect: "Aspekt",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Neprestano tražim načine kako poboljšati našu ponudu za naše klijente. Postoje li, prema vašem mišljenju, aspekti koje bismo mogli poboljšati?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Usput, ako postoji određena tema kojom biste želeli da se naš tim pozabavi, slobodno je podelite. Ovde sam ne samo da slušam, već i da se uključim i delujem na osnovu vaših briga ili ideja.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Kako bismo pružili bolju pomoć, ljubazno molimo vaše podatke, uključujući vaše ime, adresu e-pošte i kontakt broj. Te će nam informacije omogućiti da vam brzo odgovorimo i kontaktiramo vas.",

  // Survey Pages Location
  "select-the-location-you-visited": "Izaberite lokaciju koju ste posetili",
  locations: "Lokacije",
  "is-this-your-current-location": "Je li ovo vaša trenutna lokacija?",
  "nearest-location": "Najbliža lokacija",
  "loading-data": "Učitavanje podataka...",
  "please-wait": "Pričekajte!",

  // Survey Pages Location Area
  "location-area": "Područje lokacije",
  "select-location-area": "Izaberite područje lokacije",

  // Survey Pages Login
  "please-enter-your-password": "Unesite svoju lozinku",
  "value-must-be-longer-than-3-characters":
    "Vrednost mora biti duža od 3 znaka",
  "please-enter-your-email-address": "Unesite svoju adresu e-pošte",
  password: "Lozinka",
  "internal-server-error": "Interna greška poslužitelja!",
  "sign-in": "Prijava",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey": "Već ste popunili ovu anketu!",
  "csat-link-invalid": "Ovaj link ka anketi više nije važeći.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Vaše povratne informacije su poslane. Vaš broj prijave je #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Član tima uskoro će vas kontaktirati.",
  "would-you-also-like-to-rate-us-on-google":
    "Želite li nas takođe oceniti na Googleu?",
  "to-review-our-terms-and-conditions-please-click":
    "Za pregled naših Uslova i odredbi kliknite",
  here: "Ovde",
  "ticket-number-copied-to-clipboard":
    "Broj prijave kopiran u privremenu memoriju",

  // Survey Pages Welcome
  "visit-date": "Datum poseta",
  "visit-time-in": "Vreme dolaska",
  "please-select-date": "Izaberite datum",
  "guest-info": "Informacije o gostu",
  "please-select-user": "Izaberite korisnika",
  "get-started": "Započni",

  // Survey Pages InventoryType
  "enter-value": "Unesite vrednost",
  "getting-product-list": "Učitavanje liste proizvoda...",

  // Survey Pages NotesAndImage
  "upload-file": "Učitaj datoteku",

  // Survey Pages NumberType
  "enter-digit": "Unesite cifru",

  // Survey Pages TextArea
  "enter-your-comment": "Unesite svoj komentar",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Veličina datoteke mora biti manja od 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Povucite datoteke ovde, veličina datoteke manja od 10 MB ili",
  "upload-or-drag-and-drop-your-files-here":
    "Učitajte ili povucite i ispustite datoteke ovde",
  "browse-files": "Pregledaj datoteke",

  // Survey Pages Questions
  "next-question": "Sledeće pitanje",
  "save-and-exit": "Sačuvaj i izađi",
  "failed-to-save-and-exit":
    "Nije moguće sačuvati vaš napredak. Pokušajte ponovo.",
  "progress-saved-you-may-close-this-tab":
    "Vaš napredak je sačuvan. Sada možete zatvoriti ovu karticu pregledača.",
  "please-enter-at-least": "Unesite barem {min} znakova.",
  "contact-no": "Kontakt broj",
  "please-select-location": "Izaberite lokaciju!",
  "please-select-survey": "Izaberite anketu!",
  "please-enter-your-email-address-or-phone-number":
    "Unesite svoju adresu e-pošte ili broj telefona.",

  // Utils CompressFiles
  "compression-error": "Greška pri kompresiji:",

  // Web Rating FrontLogin
  "enter-location-id": "Unesite ID lokacije",
  "invalid-location-id": "Nevažeći ID lokacije",
  "location-id-required": "ID lokacije je obavezan",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Recite nam kakvo je bilo vaše današnje iskustvo.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Žao nam je čuti da danas niste imali najbolje iskustvo s nama, možete li istaknuti što je pošlo po zlu?",
  "enter-valid-email-address": "Unesite ispravnu adresu e-pošte.",
  "can-we-get-in-touch-with-you": "Možemo li vas kontaktirati?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Unesite svoj telefonski broj",
  "write-your-feedback": "Napišite svoje povratne informacije",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Po čemu se {employeeName} istaknuo za vas?",
  team: "Tim",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Vratite se na prethodni korak i izaberite zaposlenog; bez izbora zaposlenog nije moguće poslati obrazac s povratnim informacijama",
  "share-us-your-experience-with-us-today":
    "Podelite s nama svoje današnje iskustvo...",
  "did-employee-name-provide-exceptional-service":
    "Je li {employeeName} pružio izuzetnu uslugu?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Je li se {employeeName} istaknuo u pružanju izuzetne usluge?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Unesite korisničko ime",
  "please-enter-password": "Unesite lozinku",

  // Web Rating New RatingLocations
  search: "Pretraži",
  "select-loction-to-ratings": "Izaberite lokaciju za ocenjivanje",
  location: "Lokacija",
  "is-this-your-location": "Je li ovo vaša lokacija?",
  "fetch-details-failed": "Učitavanje detalja nije uspelo",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Kliknite koliko god želite",
  "what-made-employee-name-stand-out-to-you":
    "Po čemu se {employeeName} istaknuo za vas?",
  "what-made-the-team-stand-out-to-you": "Po čemu se tim istaknuo za vas?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Jesmo li se istaknuli u pružanju izuzetne usluge?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Ostavite e-poštu ili broj telefona ako želite da vas kontaktiramo, u protivnom ostavite prazno pa pritisnite Dalje",
  "anything-else-you-d-like-to-share": "Želite li još nešto podeliti?",
  "enter-valid-email": "Unesite ispravnu e-poštu",
  message: "Poruka",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Popunjavanjem obrasca pristajete na naše Uslove i Pravila privatnosti.",

  // Web Rating New FrontWebLogin
  login: "Prijava",
  username: "Korisničko ime",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Pritisnite izraz lica koji najbolje predstavlja kako se osećate u vezi sa svojim iskustvom.",
  "getting-employee-list": "Učitavanje liste zaposlenih",
  "getting-skill-data": "Učitavanje podataka o veštinama",
  "getting-screen-saver": "Učitavanje čuvara ekrana",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Hvala što ste nas kontaktirali.",
  "we-ll-be-in-touch-very-soon": "Javit ćemo vam se vrlo brzo.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Možete pratiti ovo dugme kako biste nas ocenili na Googleu",
  "rate-us-on-google": "Ocenite nas na Googleu",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Kontaktirajte nas",
  "or-you-may-reach-us-on": "...ili nas možete kontaktirati na.",
  "do-you-want-to-learn-more-about-serve-first":
    "Želite li saznati više o Serve Firstu?",

  // Web Rating New CommonComponents BottomBar
  saving: "Čuvanje",
  "please-enter-only-digits-for": "Unesite samo cifre za",
  "please-enter": "Unesite",
  "enter-value-here": "Unesite vrednost ovde",

  // Survey Pages Questions Dropdown
  "please-select": "Izaberite",
  "survey-retry-message": "Moći ćete popuniti ovu anketu nakon {value} {unit}.",
  minute: "minuta",
  minutes: "minuta",
  hour: "sat",
  hours: "sati",
  day: "dan",
  days: "dana",
  week: "sedmica",
  weeks: "sedmica",
  month: "mesec",
  months: "meseci",
  clear: "Očisti",

  "powered-by": "Pokreće",
  "image-is-required": "Slika je obavezna",
  "please-fill-all-required-contact-information":
    "Popunite sve obavezne kontakt informacije",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Ostavite dodatne povratne informacije u okviru ispod.",
  "all-feedback-is-confidential": "Sve povratne informacije su poverljive",
  "your-feedback-has-been-received-thank-you":
    "Vaše povratne informacije su primljene, hvala vam",
  "close-page": "Zatvori stranicu",
  send: "Pošalji",
  sending: "Slanje",
  "enter-your-feedback-here": "Unesite svoje povratne informacije ovde",
  "for-anything-else-please": "Za sve ostalo ",
  "please-correct-the-custom-field-values":
    "Ispravite vrednosti prilagođenih polja",
  "please-complete-all-required-contact-information":
    "Popunite sve obavezne kontakt informacije",
  "survey-cannot-be-submitted": "Anketu nije moguće poslati",
  "please-enter-your-phone": "Unesite svoj telefon",
  "network-error-please-try-again":
    "Greška mreže. Proverite svoju vezu i pokušajte ponovo.",
  "no-results-found": "Nema pronađenih rezultata",
  "drop-files-here": "Ispustite datoteke ovde...",
  "drag-drop-files":
    "Povucite i ispustite datoteke ovde ili kliknite za izbor datoteka",
  "max-5-files-5mb": "Najviše 5 datoteka, po 5 MB, samo slike",
  remove: "Ukloni",

  // Learning & Development

  "ld-module-title": "Učenje i razvoj",
  "ld-no-sign-in-required": "Prijava nije potrebna",
  "ld-progress-warning":
    "Ne zatvarajte ovaj prozor — vaš napredak se ne čuva i morali biste da počnete ispočetka.",
  "ld-loading-module": "Učitavanje modula za učenje…",
  "ld-unable-load-module": "Nije moguće učitati modul za učenje.",
  "ld-package-not-configured": "Paket za učenje nije konfigurisan.",
  "ld-start-guidance": "Započni obuku",
  "ld-due-date": "Rok {date}",
  "ld-whats-involved": "Šta je uključeno",
  "ld-your-progress": "VAŠ NAPREDAK",
  "ld-step-of": "Korak {current} od {total}",
  "ld-watched-in-full": "Pogledano u celosti",
  "ld-video-no-skip": "Možete premotati unazad, ali ne unapred",
  "ld-video-muted-counts": "Isključen zvuk — reprodukcija se i dalje računa",
  "ld-maximize-document": "Uvećaj dokument",
  "ld-minimize-document": "Smanji dokument",
  "ld-read-percent": "{percent} % pročitano",
  "ld-end-of-document": "Kraj dokumenta",
  "ld-scroll-to-continue": "Pomerite da biste nastavili",
  "ld-read-to-end": "Pročitano do kraja",
  "ld-read-to-end-to-continue": "Pročitajte do kraja da biste nastavili",
  "ld-loading-document": "Učitavanje dokumenta…",
  "ld-pdf-preview-unavailable": "Nije moguće pregledati ovaj PDF u pregledaču.",
  "ld-pdf-page-alt": "{title} — strana {page}",
  "ld-knowledge-check": "PROVERA ZNANJA",
  "ld-knowledge-check-title": "{title} — provera znanja",
  "ld-quiz-instruction":
    "Odgovorite na {count, plural, one {# pitanje} few {# pitanja} other {# pitanja}}. Prolazni prag {passMark} %.",
  "ld-quiz-instruction-pass-only": "Prolazni prag {passMark} %.",
  "ld-question-of": "PITANJE {current} OD {total}",
  "ld-guidance-of": "OBUKA {current} OD {total}",
  "ld-loading-questionnaire": "Učitavanje upitnika…",
  "ld-preparing-questions": "Priprema vaših pitanja",
  "ld-submit-answers": "Pošalji odgovore",
  "ld-submitting": "Slanje…",
  "ld-ready-to-submit": "Spremno za slanje odgovora",
  "ld-answer-selected": "Odgovor izabran",
  "ld-select-answer": "Izaberite jedan odgovor da biste nastavili",
  "ld-pass-mark-note":
    "Potrebno vam je {passMark} % ili više da biste položili. Odgovori se ne mogu menjati nakon slanja.",
  "ld-questionnaire-not-configured": "Upitnik nije konfigurisan.",
  "ld-unable-load-questionnaire": "Nije moguće učitati upitnik.",
  "ld-no-visible-questions":
    "Trenutno nema dostupnih pitanja za ovu proveru znanja.",
  "ld-unable-submit-answers": "Nije moguće poslati odgovore. Pokušajte ponovo.",
  "ld-not-passed": "Nije položeno",
  "ld-completed": "Završeno",
  "ld-fail-title": "Skoro ste uspeli — pokušajte ponovo",
  "ld-fail-description":
    "Ostvarili ste {score} — prolazni prag je {passMark} %. Preostalo vam je {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# pokušaj} few {# pokušaja} other {# pokušaja}}",
  "ld-attempt-of": "Pokušaj {current} od {total}",
  "ld-fail-alert":
    "Odvojite trenutak da ponovo pregledate vodič, zatim ponovo uradite proveru. Nakon poslednjeg pokušaja provera će biti zaključana.",
  "ld-try-again": "Pokušaj ponovo",
  "ld-review-guidance": "Pregledaj vodič",
  "ld-locked-title": "Ova obuka je sada zaključana",
  "ld-locked-description":
    "Ostvarili ste {score} — prolazni prag za ovaj paket je {passMark} %. Iz razloga usklađenosti ne možete ga ponovo raditi ovde.",
  "ld-speak-to-manager": "Razgovarajte sa svojim menadžerom",
  "ld-locked-manager-copy":
    "Vaš menadžer smene može ponovo dodeliti {courseTitle} kako biste mogli ponovo da prođete vodič i ponovo uradite proveru.",
  "ld-close-window": "Sada možete zatvoriti ovaj prozor.",
  "ld-close-window-safe": "Sada možete bezbedno zatvoriti ovaj prozor.",
  "ld-success-title": "Čestitamo!",
  "ld-success-description":
    "Uspešno ste završili {courseTitle}. Ovo je zabeleženo u vašem profilu obuke — nema više ništa da uradite.",
  "ld-email-yourself": "Pošaljite kopiju sebi",
  "ld-email-copy-description":
    "Pošaljite potvrdu o završetku u svoju poštu za evidenciju.",
  "ld-email-placeholder": "vi@kompanija.com",
  "ld-sent": "Poslato",
  "ld-sending-email": "Slanje…",
  "ld-unable-send-email": "Nije moguće poslati e-poštu. Pokušajte ponovo.",
  "ld-email-sent-success": "E-pošta o potvrdi je uspešno poslata!",
  "ld-video-briefing": "Video brifing",
  "ld-document": "Dokument",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · bez preskakanja",
  "ld-document-meta": "Dokument · PDF",
  "ld-document-meta-scroll": "Dokument · PDF · pomerite do kraja",
  "ld-video-instruction-full":
    "Pogledajte u celosti — ne možete preskakati unapred",
  "ld-video-instruction": "Pogledajte brifing, zatim nastavite",
  "ld-document-instruction-scroll": "Pomerite do kraja da biste nastavili",
  "ld-document-instruction": "Pregledajte dokument, zatim nastavite",
  "ld-questionnaire": "Upitnik",
  "ld-confirmation": "Potvrda",
  "ld-question-count":
    "{count, plural, one {# pitanje} few {# pitanja} other {# pitanja}}",
  "ld-knowledge-check-subtitle": "Provera znanja",
  "ld-score": "Rezultat",
  "ld-whats-involved-pass-mark":
    "Prolazni prag {passMark} % · otključava se nakon vodiča",
  "ld-document-type-pdf": "{documentType} · PDF",
};
